import { Map, User, ShoppingCart, Phone, Mail } from 'lucide-react'

export const MENU_ACTIONS = [
  {
    id: '1',
    icon: Map,
    type: 'openMaps',
    label: 'Abrir no Maps',
  },
  {
    id: '2',
    icon: Phone,
    type: 'makeCall',
    label: 'Ligar',
  },
  {
    id: '3',
    icon: Mail,
    type: 'sendEmail',
    label: 'Enviar Email',
  },
  {
    id: '4',
    icon: User,
    type: 'perfil',
    label: 'Perfil',
  },
  {
    id: '5',
    icon: ShoppingCart,
    type: 'startOrder',
    label: 'Pedido',
  },
]